import "./styles.scss";

import Popup from "reactjs-popup";
import { useTranslation } from "react-i18next";
import { Fragment, useEffect, useState } from "react";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";

import IconInfo from "../../../assets/images/icon_info.svg";
import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";
import IconAvatar from "../../../assets/images/profile/img_placeholder.svg";
import { getContentLinkWithSequentialScheduleId, handleSelectColor } from "../../../utils/utils";

function CardPreviousClasses({ data, index, length, sequentialScheduleId }) {
  const { t } = useTranslation();

  const [showDetail, setShowDetail] = useState(false);

  const lastContentFile = data[0]?.contentFile;
  const isPending = data[0]?.status === "pendent" || data[0]?.status === "pendent-delayed";
  const isExpired =
    data[0]?.status === "expired" ||
    data[0]?.status === "pendent-expired" ||
    data[0]?.status === "expired-delayed" ||
    data[0]?.status === "pendent-delayed-expire" ||
    data[0]?.status === "pendent-delayed-expired";

  const renderPopup = (value, max) => (
    <Popup
      on={"hover"}
      position={"top center"}
      trigger={<p className="descriptionContent">{value?.slice(0, max).concat("...")}</p>}
      style={{ width: 300, zIndex: 999999999, marginLeft: 20 }}
    >
      <div>
        <p>{value}</p>
      </div>
    </Popup>
  );

  const renderCycleAndLevel = (item) => {
    if (item[0]?.contentFile === null && item[0]?.cycleAndLevel.length === 0) return;

    let levelCycle = "";
    let levelStudent = "";

    if (item[0]?.contentFile === null) {
      levelStudent = item[0]?.cycleAndLevel[0]?.level === "DM" ? "C2" : item[0]?.cycleAndLevel[0]?.level;
      levelCycle = item[0]?.cycleAndLevel[0]?.contentCycle ?? 1;
    } else {
      levelStudent = item[0]?.contentFile?.level;
      levelCycle = item[0]?.contentFile?.cycle ?? 1;
    }

    return (
      <div className="wrapperLevelAndCycle">
        <div className="columnItem">
          <span className={`level ${handleSelectColor(levelStudent)}`}>
            {levelStudent === "DEMO" ? "D" : levelStudent}
          </span>
        </div>
        <div className="columnItem">
          <span className="titleContent">{t("CYCLE")}</span>
          <span className={`cicle ${handleSelectColor(levelStudent)}`}>{levelCycle}</span>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (length === 1 && index === 0) setShowDetail(true);
    if (length === 2 && index === 1) setShowDetail(true);
    if (length === 3 && index === 2) setShowDetail(true);
    // eslint-disable-next-line
  }, [index]);

  if (isPending || isExpired) {
    return (
      <div className="contentCard">
        <div className="rowContent">
          <div className="wrapperPendetn">
            <img src={IconInfo} alt="iconInfo" />
            <p>{isPending && t("WAITING_TEACHE_UPDATE")}</p>
            <p>{isExpired && t("CLASS_EXPIRED")}</p>
          </div>

          <div className="columnItem">
            <div className="divAvatar">
              <img
                alt="avatar"
                className="avatar"
                src={data[0]?.teacher?.user?.picture ? data[0]?.teacher?.user?.picture : IconAvatar}
              />
              <div>
                <span className="titleContent">{t("CARD_CLASS_TEACHER")}</span>
                <span className="spanContent">{decryptIfEncrypted(data[0]?.teacher?.user?.name.split(" ")[0])}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contentCard">
      <div className="rowContent">
        {lastContentFile && (
          <>
            <a
              target="_blank"
              rel="noreferrer"
              href={getContentLinkWithSequentialScheduleId(lastContentFile?.linkForTeacher, sequentialScheduleId)}
            >
              <span className="contentCodePast">{lastContentFile?.contentCode}</span>
            </a>
            <div className="columnItem w-120">
              <span className="titleContent">{t("CLASS_TITLE")}</span>
              <span className="spanContent">{renderPopup(lastContentFile?.classTitle, 10)}</span>
            </div>
            <div className="columnItem w-120">
              <span className="titleContent">{t("CYCLE_NAME")}</span>
              <span className="spanContent">{renderPopup(lastContentFile?.cycleName, 10)}</span>
            </div>
          </>
        )}
        {data[0]?.classFocus?.toLowerCase() === "specific" && (
          <span className="contentCodePast">{t("BTN_SPECIFIC")}</span>
        )}

        {renderCycleAndLevel(data)}

        <div className="columnItem">
          <div className="divAvatar">
            <img
              width={40}
              height={40}
              alt="avatar"
              className="avatar"
              src={data[0]?.teacher?.user?.picture ? data[0]?.teacher?.user?.picture : IconAvatar}
            />
            <div>
              <span className="titleContent">{t("CARD_CLASS_TEACHER")}</span>
              <span className="spanContent">{renderPopup(decryptIfEncrypted(data[0]?.teacher?.user?.name), 7)}</span>
            </div>
          </div>
        </div>

        <div className="actions">
          {lastContentFile && (
            <a
              target="_blank"
              rel="noreferrer"
              href={getContentLinkWithSequentialScheduleId(lastContentFile?.linkForStudent, sequentialScheduleId)}
            >
              <span className="contentCodePast codeStudent">{lastContentFile?.contentCode}</span>
            </a>
          )}

          {showDetail ? (
            <TiArrowSortedUp size={25} color={"#565D66"} onClick={() => setShowDetail((state) => !state)} />
          ) : (
            <TiArrowSortedDown size={25} color={"#565D66"} onClick={() => setShowDetail((state) => !state)} />
          )}
        </div>
      </div>

      {showDetail && (
        <Fragment>
          <div className="cardDetail">
            <div>
              {data.map((item, index) => (
                <a
                  key={index}
                  target="_blank"
                  rel="noreferrer"
                  href={getContentLinkWithSequentialScheduleId(item?.contentFile?.linkForTeacher, sequentialScheduleId)}
                >
                  <span className="contentCodePast">
                    {item?.contentFile ? item?.contentFile?.contentCode : t("BTN_SPECIFIC")}
                  </span>
                </a>
              ))}
            </div>

            <textarea
              rows="5"
              cols="90"
              disabled
              value={data[0]?.studentCommentByTeacher || data[0]?.specificClassTeacherComment}
            />
          </div>

          {data[0].suggestedExercisesByTeacher && (
            <div className="suggestedExercisesByTeacher">
              {data[0].suggestedExercisesByTeacher.split(", ").map((item, index) => (
                <div key={index}>
                  <p>
                    <strong>#</strong>
                    {item}
                  </p>
                </div>
              ))}
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
}

export default CardPreviousClasses;
